var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyReward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40621 6.3069C3.45749 8.36023 5.10395 10.1571 7.15792 10.1571C9.24412 10.1571 10.8514 8.38921 10.9086 6.30379C10.9156 6.04733 10.9193 5.78898 10.9193 5.52877C10.9193 4.29901 10.8445 3.09677 10.7174 1.95825C10.6711 1.5437 10.3589 1.20823 9.9475 1.13948C9.04584 0.988789 8.12056 0.900452 7.15792 0.900452C6.19313 0.900452 5.25109 0.983624 4.35339 1.13712C3.9491 1.20625 3.64346 1.53622 3.59654 1.94369C3.46522 3.08398 3.39648 4.29447 3.39648 5.52877C3.39648 5.79011 3.39979 6.04947 3.40621 6.3069Z",
    fill: "#C3DE45",
    stroke: "#084629",
    strokeWidth: 1.46696
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 10.1649V13.1255",
    stroke: "#084629",
    strokeWidth: 1.46696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80859 13.1243H9.51038",
    stroke: "#084629",
    strokeWidth: 1.46696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 1.83936H12.2916C12.8317 1.83936 13.2696 2.27721 13.2696 2.81733V2.99003C13.2696 3.90556 12.9724 4.78359 12.4433 5.43097C12.0259 5.94177 11.4911 6.27596 10.9165 6.39423",
    stroke: "#084629",
    strokeWidth: 1.46696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 1.83936H2.03052C1.4904 1.83936 1.05254 2.27721 1.05254 2.81733V2.99003C1.05254 3.90556 1.34976 4.78359 1.87882 5.43097C2.29395 5.93895 2.82515 6.27226 3.39614 6.39225",
    stroke: "#084629",
    strokeWidth: 1.46696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyReward);
export default __webpack_public_path__ + "static/media/trophy-reward.93faad28a670429a0e22a87631030387.svg";
export { ForwardRef as ReactComponent };